export default "__VITE_ASSET__BX8hgA8F__"